import carouselTimeline from '../js/modules/carouselTimeline';

// Layouts

// Elements

// Blocks
import '../scss/blocks/card_timeline.scss';
import '../scss/blocks/panel_timeline.scss';

// Init modules
carouselTimeline();
